import { Component, OnInit } from '@angular/core';
import { HomeService } from '../home.service';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { NotificationService } from 'app/shared/notifications/notification.service';
import { EVENT_RATE_CACHE_STORAGE_KEY } from 'app/shared/utils/event-rate-cache';

@Component({
  selector: 'usb-event-rate-mannager',
  templateUrl: './event-rate-mannager.component.html',
  styleUrls: ['./event-rate-mannager.component.scss']
})
export class EventRateMannagerComponent implements OnInit {
  agencyInfo: any;
  infoEventRate: any[] = [];
  title: string = '';
  mannagementOption: string = '';
  targetRegion: string | null = null;
  targetCategoria: string | null = null;
  private _unsubscribeAll: Subject<any> = new Subject<any>();
  constructor(
                private homeService: HomeService,
                private activatedRoute: ActivatedRoute,
                private notificationService: NotificationService

              ) { }

  ngOnInit(): void {
    const selectedAgency = localStorage.getItem('selectedAgency');
    this.agencyInfo = JSON.parse(selectedAgency);
    this.suscriptionParam();

  }

  suscriptionParam(): void {
    this.activatedRoute.queryParams
        .pipe(takeUntil(this._unsubscribeAll))
        .subscribe(queryParams => {
          this.targetRegion = queryParams['region'] || null;
          this.targetCategoria = queryParams['categoria'] || null;
        });

    this.activatedRoute.params
        .pipe(takeUntil(this._unsubscribeAll))
        .subscribe(params => {

          let infoUrl: any;

          this.mannagementOption = params['mannagementOption'];

          if(this.mannagementOption) {
            infoUrl = this.getDataAgencyInfo(this.mannagementOption);

            // Si venimos de usb-packages-small (goToCircuits), ya tenemos esta misma consulta
            // resuelta (mismos params, misma agencyInfo) — evita pedirla de nuevo.
            const cached = this.readCachedRates(infoUrl.type);
            if (cached) {
              this.title = cached.tipoNombre === 'circuito' ? 'Paquetes' : cached.tipoNombre;
              this.infoEventRate = cached.regiones;
              this.scrollToTarget();
            } else {
              this.getDataMannager(infoUrl);
            }
          }

        });
  }

  getDataAgencyInfo(routeParam: string): any {

    let paramsUrl = {};

    paramsUrl = this.paramsUrlInit();

    switch(routeParam) {

      case 'circuit':
        paramsUrl['type'] = 1;
        break;
      case 'rate':
        paramsUrl['type'] = 2;
        break;
      case 'tools':
        paramsUrl['type'] = 3;
        break;
      case 'national':
        paramsUrl['type'] = 4;
        break;
      case 'deals':
        paramsUrl['type'] = 5;
        break;

    }

    return paramsUrl;
  }

  paramsUrlInit(): any {
    return {
      channel: this.agencyInfo?.channel_id === 2 ? 'minorista' : 'mayorista',
      location_agency_id: this.agencyInfo?.location_agency_id === 1 ? 'exterior' : 'exterior',
      language: this.agencyInfo?.language === 39 ? 2 : 1,
    };
  }


  getDataMannager(infoAgency: any): void {
    this.homeService.ratesInfo(infoAgency).subscribe({
      next: (res: any) => {
        if(res) {
          this.title = res.tipo_nombre;
          this.title = this.title === 'circuito' ? 'Paquetes' : this.title;
          this.infoEventRate = res.regiones;
          this.scrollToTarget();
        }
      },
      error: (error: HttpErrorResponse) => {
        console.log(error);
      }
    });
  }


  getUrlDownload(dataUrl: any) {
    this.notificationService.info('Su descarga comienza en un momento');
    const paramsUrl = this.paramsUrlInit();
    this.homeService.downloadDocument(dataUrl, paramsUrl);
  }

  // Región a la que se llega con un link tipo "Ver más en {región}" desde usb-packages-small.
  isTargetRegion(regionName: string): boolean {
    return !!this.targetRegion && this.normalize(regionName) === this.normalize(this.targetRegion);
  }

  categoriaAnchorId(regionName: string, categoriaName: string): string {
    return `categoria-${this.slugify(regionName)}-${this.slugify(categoriaName)}`;
  }

  // Espera a que Angular renderice el *ngFor y a que termine la animación de apertura del acordeón,
  // busca la región/categoría objetivo y hace scroll hasta la card correspondiente.
  private scrollToTarget(): void {
    if (!this.targetRegion) {
      return;
    }

    setTimeout(() => {
      const region = this.infoEventRate
        .find((r: any) => this.normalize(r.region) === this.normalize(this.targetRegion));
      if (!region) {
        return;
      }

      const categorias = region.categorias || [];
      const categoriaMatch = categorias
        .find((c: any) => this.normalize(c.categoria_nombre) === this.normalize(this.targetCategoria));
      const categoriaName = categoriaMatch ? categoriaMatch.categoria_nombre : categorias[0]?.categoria_nombre;
      if (!categoriaName) {
        return;
      }

      const element = document.getElementById(this.categoriaAnchorId(region.region, categoriaName));
      if (!element) {
        return;
      }

      // scrollIntoView({block:'start'}) deja la card tapada por el header fixed, así que se descuenta ese alto a mano.
      const fixedHeaderOffset = 240;
      const top = element.getBoundingClientRect().top + window.pageYOffset - fixedHeaderOffset;
      window.scrollTo({ top, behavior: 'smooth' });
    }, 400);
  }

  private normalize(value: string | null | undefined): string {
    return (value || '').trim().toLowerCase();
  }

  private slugify(value: string): string {
    return (value || '')
      .normalize('NFD')
      .replace(/[̀-ͯ]/g, '')
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '');
  }

  // Se consume una sola vez (se borra apenas se lee), así una visita posterior a esta misma
  // pantalla (sin venir de packages-small) siempre pide datos frescos.
  private readCachedRates(type: number): { tipoNombre: string; regiones: any[] } | null {
    const stored = sessionStorage.getItem(EVENT_RATE_CACHE_STORAGE_KEY);
    sessionStorage.removeItem(EVENT_RATE_CACHE_STORAGE_KEY);
    if (!stored) {
      return null;
    }

    try {
      const parsed = JSON.parse(stored);
      return parsed?.type === type ? parsed : null;
    } catch {
      return null;
    }
  }

}
